import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { Button } from '@one-thd/sui-atomic-components';
import { useImpression, ImpressionProvider } from '@thd-olt-component-react/impression';
import { SnapshotTabView } from './snapshot-tab-view/SnapshotTabView';
import { ProAlertsAndUpdatesHeader } from './ProAlertsAndUpdatesHeader';
import { triggerViewAccountDashboardClick } from '../utils/analyticsEvents';

const { string } = proptypes;

const ProAlertsAndUpdatesComponent = ({ componentId = '' }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('pro-alerts-and-updates.ready'); }, []);

  // The one tracked impression (WOR2-950): the component itself.
  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: 'ProAlertsAndUpdates',
      component: 'ProAlertsAndUpdates',
      type: 'content',
      position: 1,
    },
  });

  const viewAccountDashboardClick = () => {
    triggerViewAccountDashboardClick(componentId);
  };

  return (
    <QueryProvider cacheKey="pro-alerts-and-updates">
      {/* Fills its layout cell so it matches Loyalty's height beside it; no margin, for the same reason. */}
      <div className="sui-w-full sui-max-w-screen-2xl sui-m-auto sui-h-full sui-flex sui-flex-col">
        <section
          data-component="ProAlertsAndUpdates"
          className="sui-flex sui-flex-col sui-grow sui-rounded-lg sui-overflow-hidden
          sui-border-1 sui-border-solid sui-border-primary"
          ref={ref}
          // eslint-disable-next-line react/no-unknown-property
          clickid={clickID}
        >
          <ProAlertsAndUpdatesHeader componentId={componentId} />
          {/* Mobile insets come from SnapshotTabView and the footer link; bg-primary matches the borderless cards. */}
          <div
            className="sui-flex sui-flex-col sui-grow sui-gap-2 sui-min-w-0 sui-pt-4 sui-pb-6 sm:sui-pb-0 sm:sui-px-4
            sui-bg-primary"
          >
            <SnapshotTabView componentId={componentId} />
            <div className="sm:sui-hidden sui-flex sui-justify-center sui-mt-2 sui-px-4">
              <Button onClick={viewAccountDashboardClick} variant="text" href="/myaccount/dashboard">
                View Account Dashboard
              </Button>
            </div>
          </div>
        </section>
      </div>
    </QueryProvider>
  );
};

ProAlertsAndUpdatesComponent.displayName = 'ProAlertsAndUpdatesComponent';

ProAlertsAndUpdatesComponent.propTypes = {
  componentId: string,
};

export const ProAlertsAndUpdates = ({ componentId = '' }) => {
  const impressionData = {
    id: componentId,
    name: 'ProAlertsAndUpdates',
    component: 'ProAlertsAndUpdates',
    type: 'content',
    position: 1,
  };

  return (
    <ImpressionProvider data={impressionData}>
      <ProAlertsAndUpdatesComponent componentId={componentId} />
    </ImpressionProvider>
  );
};

ProAlertsAndUpdates.displayName = 'ProAlertsAndUpdates';

ProAlertsAndUpdates.propTypes = {
  componentId: string,
};

ProAlertsAndUpdates.dataModel = extend(SnapshotTabView);
